/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Document = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M22 1V23H2V1H22ZM20.5 2.5H3.5V21.5H20.5V2.5ZM13 13V14.5H5V13H13ZM19 9V10.5H5V9H19ZM19 5V6.5H5V5H19Z"
                        fill={color}
                    />
                </svg>
        );
    };
